import { render, staticRenderFns } from "./MadeupRequirementForm.vue?vue&type=template&id=290aee88&scoped=true"
import script from "./MadeupRequirementForm.vue?vue&type=script&lang=js"
export * from "./MadeupRequirementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290aee88",
  null
  
)

export default component.exports